
define('Newsletter.EntryPoint',
	[
		'Newsletter.View',
		'Newsletter.Model',
		'newsletter.tpl'
	],
	function (
		NewsletterView,
		NewsletterModel,
		newsletter_tpl
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');

				if (layout) {
					layout.addChildView('UC.Newsletter', function () {
						return new NewsletterView({ 
							container: container,
							model: new NewsletterModel() 
						});
					});
				}

				_.extend(NewsletterView.prototype, {

					template: newsletter_tpl	
							
				});

			}
		};
	});
